import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
         padding:10,
        borderBottomColor: '#C8C8C8',
        borderBottomWidth: 1,
    },
    billTo: {
        color: '#000',
        fontSize: 8,
    },
  });


  const GuestTo = ({invoice}) => (
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}>Cancellation Policy: If cancelled or modified 1 days before date of experience (tour, event, attraction, activity).</Text>
    </View>
  );
  
  export default GuestTo